// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html, body {\n    overflow: hidden;\n}\n\n.Polaris-Backdrop--transparent {\n    background: #8c8c8ca6;\n}\n\n/*.Polaris-Page {*/\n/*    height: 100vh;*/\n/*}*/", ""]);
// Exports
module.exports = exports;
